/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardMedia, CardContent, Typography, IconButton } from '@material-ui/core';
import { ChevronLeft, ChevronRight, FiberManualRecord } from '@material-ui/icons';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  bannerContainer: {
    width: '100%',
    margin: '0 auto',
    padding: '20px 0',
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 0',
    },
  },
  bannerTitle: {
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'uppercase',
    color: '#333',
    borderBottom: '2px solid #567B95',
    paddingBottom: '8px',
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
    },
  },
  titleAccent: {
    height: '12px',
    width: '12px',
    backgroundColor: '#567B95',
    marginRight: '10px',
  },
  slideshowContainer: {
    display: 'flex',
    transition: 'transform 0.3s ease',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      overflowX: 'auto',
      flexWrap: 'nowrap',
      flexDirection: 'row',
      transition: 'none',
      transform: 'none !important',
      scrollbarWidth: 'none', 
      '&::-webkit-scrollbar': { display: 'none' }, 
    },},
  slide: {
    minWidth: '100%',
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
      flexDirection: 'row',
    },
  },
  articleCard: {
    flex: 1,
    margin: '0 10px',
    borderRadius: '4px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    cursor: 'pointer',
    minWidth: 280,
    maxWidth: 320,
    [theme.breakpoints.down('sm')]: {
      minWidth: 240,
      maxWidth: 260,
      margin: '0 6px',
      flex: '0 0 auto',
    },
  },

  articleImage: {
    height: '180px',
    [theme.breakpoints.down('md')]: {
      width: '120px',
      height: '90px',
      flexShrink: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '160px',
    },
  },
  articleContent: {
    padding: '12px',
    [theme.breakpoints.down('md')]: {
      padding: '8px',
    },
  },
  articleTitle: {
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '1.3',
    marginBottom: '8px',
    color: '#121212',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      WebkitLineClamp: 2,
    },
  },
  articleAbstract: {
    fontSize: '14px',
    color: '#444',
    lineHeight: '1.4',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  navigation: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
  },
  navButton: {
    color: '#567B95',
    padding: '5px',
  },
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0 15px',
  },
  dot: {
    fontSize: '12px',
    color: '#ccc',
    margin: '0 3px',
    cursor: 'pointer',
    transition: 'color 0.2s',
  },
  activeDot: {
    color: '#567B95',
  },
  breakingBadge: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    backgroundColor: '#d32f2f',
    color: 'white',
    fontSize: '10px',
    fontWeight: 'bold',
    padding: '3px 8px',
    borderRadius: '2px',
    zIndex: 1,
  },
  articleMeta: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '8px',
    fontSize: '12px',
    color: '#666',
  },
  sectionTag: {
    backgroundColor: '#f0f0f0',
    padding: '2px 6px',
    borderRadius: '3px',
    fontWeight: '500',
  },
  placeholderImage: {
    height: '180px',
    backgroundColor: '#f0f0f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#999',
    [theme.breakpoints.down('md')]: {
      width: '120px',
      height: '90px',
      flexShrink: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '160px',
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
  },
}));

const HomePageBanner = ({ data }) => {
  const classes = useStyles();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [articles, setArticles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (data && data.length > 0) {
      const groupedArticles = [];
      for (let i = 0; i < data.length; i += 4) {
        
        groupedArticles.push(data.slice(i, i + 4));
      }
      setArticles(groupedArticles);
    }
  }, [data]);

  useEffect(() => {
    if (articles.length > 1) {
      const timer = setInterval(() => {
        handleNext();
      }, 5000);
      return () => clearInterval(timer);
    }
  }, [currentSlide, articles.length]);

  const getImageUrl = (url) => {
    if (url) {
      const API_BASE_URL = 'https://jtimes.zuddo.biz/main/api/getimage'+url;
      return API_BASE_URL;
    }

    return 'https://via.placeholder.com/800x400/ffffff/cccccc?text=New+York+Times';
  };
  const handleNext = () => {
    setCurrentSlide((prev) => (prev + 1) % articles.length);
  };

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev - 1 + articles.length) % articles.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

    const handleArticleClick = (id) => {
    if (id) {
      navigate(`/article/${id}`);
    }
  };

  const isMobile = window.innerWidth <= 600;

   if (!data || data.length === 0) {
    return (
      <div className={classes.bannerContainer}>
        <div className={classes.loadingContainer}>
          <Typography>Loading trending stories...</Typography>
        </div>
      </div>
    );
  }

  if (articles.length === 0) {
    return (
      <div className={classes.bannerContainer}>
        <div className={classes.loadingContainer}>
          <Typography>No articles available at the moment.</Typography>
        </div>
      </div>
    );
  }


  return (
    <div className={classes.bannerContainer}>
      <div className={classes.bannerTitle}>
        <div className={classes.titleAccent}></div>
        Trending Stories
      </div>

      <div
        className={classes.slideshowContainer}
        style={
          !isMobile
            ? { transform: `translateX(-${currentSlide * 100}%)` }
            : undefined
        }
      >
        {isMobile
          ? 
            data.map((article, idx) => (
              <Card key={idx} className={classes.articleCard} onClick={()=>handleArticleClick(article.id)}>
                {idx === 0 && <div className={classes.breakingBadge}>BREAKING</div>}
                {article?.multimedia && article.multimedia[0]?.url ? (
                  <CardMedia
                    className={classes.articleImage}
        
                    image={getImageUrl(article.multimedia[0]?.url)}
                    title={article.title || 'News image'}
                  />
                ) : (
                  <div className={classes.placeholderImage}>
                    <Typography variant="body2">No Image</Typography>
                  </div>
                )}
                <CardContent className={classes.articleContent}>
                  <Typography variant="h6" component="h3" className={classes.articleTitle}>
                    {article?.title || 'No title available'}
                  </Typography>
                  {article?.abstract && (
                    <Typography variant="body2" component="p" className={classes.articleAbstract}>
                      {article.abstract}
                    </Typography>
                  )}
                  <div className={classes.articleMeta}>
                    {article?.section && (
                      <span className={classes.sectionTag}>{article.section}</span>
                    )}
                    {article?.created_at && (
                      <span>{new Date(article.created_at).toLocaleDateString()}</span>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))
          : 
            articles.map((slide, slideIndex) => (
              <div key={slideIndex} className={classes.slide}>
                {slide.map((article, index) => (
                  <Card key={`${slideIndex}-${index}`} className={classes.articleCard} onClick={()=>handleArticleClick(article.id)}>
                    {index === 0 && <div className={classes.breakingBadge}>BREAKING</div>}
                    {article?.multimedia ? (
                      <CardMedia
                          className={classes.articleImage}
                          image={getImageUrl(article.multimedia[0]?.url)}
                          title={article.title || 'News image'}
                      />
                    ) : (
                      <div className={classes.placeholderImage}>
                        <Typography variant="body2">No Image</Typography>
                      </div>
                    )}
                    <CardContent className={classes.articleContent}>
                      <Typography variant="h6" component="h3" className={classes.articleTitle}>
                        {article?.title || 'No title available'}
                      </Typography>
                      {article?.abstract && (
                        <Typography variant="body2" component="p" className={classes.articleAbstract}>
                          {article.abstract}
                        </Typography>
                      )}
                      <div className={classes.articleMeta}>
                        {article?.section && (
                          <span className={classes.sectionTag}>{article.section}</span>
                        )}
                        {article?.created_at && (
                          <span>{new Date(article.created_at).toLocaleDateString()}</span>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            ))}
      </div>

      {!isMobile && articles.length > 1 && (
        <div className={classes.navigation}>
          <IconButton className={classes.navButton} onClick={handlePrev}>
            <ChevronLeft />
          </IconButton>
          <div className={classes.indicator}>
            {articles.map((_, index) => (
              <FiberManualRecord
                key={index}
                className={`${classes.dot} ${currentSlide === index ? classes.activeDot : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
          <IconButton className={classes.navButton} onClick={handleNext}>
            <ChevronRight />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default HomePageBanner;